import Vue from 'vue'
import Router from 'vue-router'
import config from '../Config'

Vue.use(Router);

/* Layout */
import message from "./message";
import system from "./system";
import conv from "./conv";
import log from "./log";
import userManage from "./userManage";
import finance from "./finance";
import propaganda from "./propaganda";
import operation from "./operation";
import datas from "./datas";
import main from "./main";
import productStorage from "./productStorage";
import Layout from "../views/layout/Layout";

export const constantRouterMap = [
    {path: '/login', component: () => import('@/views/login/index'), hidden: true},
    {path: '/404', component: () => import('@/views/404'), hidden: true},
    // {
    //     path: '',
    //     component: Layout,
    //     redirect: '/summary',
    //     meta: {title: '运营管理', icon: 'el-icon-s-operation'},
    //     children: [
    //         {
    //             path: 'summary',
    //             name: 'outerChain',
    //             component: () => import('@/views/operation/outerChain/index'),
    //             meta: {title: '外链聚合页配置', icon: 'product-cate'}
    //         },
    //         {
    //             path: 'leaseGuide',
    //             name: 'leaseGuide',
    //             component: () => import('@/views/operation/leaseGuide/index'),
    //             meta: {title: '租借引导页', icon: 'product-cate'},
    //         }
    //     ]
    // },
    datas,
    operation,
    propaganda,
    finance,
    userManage,
    log,
    conv,
    message,
    system,
    productStorage,
    main,
    {path: '*', redirect: '/404', hidden: true}
];

export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js